import api from './index'

let exports = {};
//
exports.getGoodsCatServicerStatisList = function (data, callback) {// 设备分类服务商服务统计报表
    api.post('/servcDeliv/goodsCat/servicer/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatVendorFulfillStatisList = function (data, callback) {// 设备分类供应商履约率统计报表
    api.post('/servcDeliv/goodsCat/vendor/fulfill/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatVendorPSQMStatisList = function (data, callback) {// 供应商客观评价数据统计
    api.post('/servcDeliv/goodsCat/vendor/psqm/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getGoodsCatServicerFulfillStatisList = function (data, callback) {// 设备分类供应商履约率统计报表
    api.post('/servcDeliv/goodsCat/servicer/fulfill/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerPSQMStatisList = function (data, callback) {// 设备分类供应商履约率统计报表
    api.post('/servcDeliv/servicer/psqm/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/psqm.js
// module id = 154
// module chunks = 0